import { ErrorTip } from '@/utils/class/ErrorTip'

class ContainerNoHelper {
  static checkContainerNo(containerNo) {
    if (!containerNo) {
      return false
    }
    if (containerNo.length !== 11) {
      return false
    }
    try {
      const chk = this.getCheckDigit(containerNo)
      if (chk === (containerNo.charCodeAt(10) - 48)) {
        return true
      }
      return false
    } catch (error) {
      return false
    }
  }
  static getCheckDigit(containerNo) {
    let total = 0
    for (let i = 0; i < 4; ++i) {
      const char = containerNo.charCodeAt(i)
      if (char === 65) {
        total = total + 10 * (1 << i)
      } else if (char > 65 && char < 76) {
        total = total + (char - 54) * (1 << i)
      } else if (char > 75 && char < 86) {
        total = total + (char - 53) * (1 << i)
      } else if (char > 85 && char < 91) {
        total = total + (char - 52) * (1 << i)
      } else {
        throw new ErrorTip('Invalid charactor')
      }
    }
    for (let i = 4; i < 10; ++i) {
      const char = containerNo.charCodeAt(i)
      if (char > 47 && char < 58) {
        total = total + (char - 48) * (1 << i)
      } else {
        throw new ErrorTip('Invalid charactor')
      }
    }
    total = (total % 11) % 10
    return total
  }
}
export default ContainerNoHelper
